import { ShuffleAnswers as ShuffleAnswersPresenter } from './presenter';
import { connect, getActiveQuiz, getActiveQuizId, setQuizShuffleAnswers } from '@instructure/quiz-core';
function mapStateToProps(state) {
  return {
    shuffleAnswers: getActiveQuiz(state).shuffleAnswers,
    activeQuizId: getActiveQuizId(state)
  };
}
export var ShuffleAnswers = connect(mapStateToProps, {
  setQuizShuffleAnswers: setQuizShuffleAnswers
})(ShuffleAnswersPresenter);
export default ShuffleAnswers;